module.exports = __webpack_public_path__ + "static/bg-header-1c2890faed6d51957ac1ce50074a660e.png";